export function appSidebarPermissionFailedMessage() {
  return "Permission response could not be sent. Check the connection and try again."
}

export function appSidebarRenameFailedMessage() {
  return "App chat name could not be saved. Try a shorter name or try again."
}

export function appSidebarArchiveFailedMessage() {
  return "App chat could not be archived. Try again from the chat menu."
}

export function appSidebarSendFailedMessage() {
  return "App chat message could not be sent. Check the selected model and try again."
}
